import { type MessageDataType, type IRoomSendMessageResult } from '@tencent/docs-connection';
import { ErrorSource } from '../constants';
import { type IRevisionHandler } from '../types';
import { SubmitHandler } from './submit-handler';

export class SubmitSendErrorHandler extends SubmitHandler {
    protected errorSource = ErrorSource.Room;

    public constructor(submitHandler: IRevisionHandler, moduleName: string) {
        super(submitHandler, moduleName);
    }
    /**
     * 房间层返还提交错误结果
     * @param taskId
     * @param cmd
     * @param data
     * @param result
     */
    public onSubmitError = (taskId: number, cmd: string, data: MessageDataType, result: IRoomSendMessageResult) => {
        const errCode = this.handleConnectionLayerResponse(result);
        if (errCode === 0) return;
        this.handleResponseError(taskId, result);
    };

    /**
     * 发送成功回调
     * @param taskId
     * @param cmd
     * @param data
     * @param result
     * @returns
     */
    public onSubmitSend = (taskId: number, cmd: string, data: MessageDataType, result: IRoomSendMessageResult) => {
        const errCode = this.handleConnectionLayerResponse(result);
        if (errCode === 0) {
            // 发送成功
            this.submitHandler.updateRetryPostCount(0);
            return;
        }
        // 消息失败
        this.submitHandler.logger.warn(this.moduleName, `[${taskId}] send userChange failed, reason: ${errCode}`);
        this.handleResponseError(taskId, result);
    };
}
